import { 
    PropertyTransferScreens, 
    Unit, 
    PropertyTransferEntryPoints, 
    TransferProperty,
    TransferDetailsType,
    OffplanRoles
} from "@/components/PropertyTransfer/PropertyTransfer.types";
import { PaymentStatus } from "@/components/Payments/PaymentOptions/PaymentOptions.types";
import { 
    createSlice, 
    PayloadAction 
} from "@reduxjs/toolkit";

/**
 * Interface for the offplan transfer state in Redux
 */
export interface OffplanTransferState {
    currentPage: PropertyTransferScreens;
    selectedUnit: Unit | null;
    source?: PropertyTransferEntryPoints;
    propertyDetails: TransferProperty | null;
    transferDetails: TransferDetailsType | null;
    role: OffplanRoles | null,
    allTransfers: TransferProperty[],
    transfersByRole: TransferProperty[],
    paymentStatus: PaymentStatus;
    paymentReferenceId: string;
}

const initialOffplanTransfer: OffplanTransferState = {
  currentPage: PropertyTransferScreens.SELECT_UNIT,
  selectedUnit: null,
  propertyDetails: null,
  transferDetails: null,
  role: null,
  allTransfers: [],
  transfersByRole: [],
  paymentStatus: PaymentStatus.IDLE,
  paymentReferenceId: ''
};

const offplanTransferSlice = createSlice({
    name: "offplanTransferReducer",
    initialState: { ...initialOffplanTransfer },
    reducers: {
        setOffplanTransfer: (state, action: PayloadAction<Partial<OffplanTransferState>>): OffplanTransferState => {
            return {
                ...state,
                ...action.payload,
            };
        },
        resetOffplanTransfer: (): OffplanTransferState => {
            return {
                ...initialOffplanTransfer,
            };
        },
    },
});

export const { setOffplanTransfer, resetOffplanTransfer } = offplanTransferSlice.actions;
export default offplanTransferSlice.reducer;
